module.exports = __webpack_public_path__ + "static/media/599.702_6.72acea3e.pdf";